import type { CellCoord, CellRef } from '@nebalkon-workspace/storage-api';

export function warehouseCellKey(cell: CellCoord): string {
  return `${cell.row_number}-${cell.floor}-${cell.col_number}`;
}

export function formatWarehouseCellLabel(cell: CellCoord): string {
  return warehouseCellKey(cell);
}

export function cellCoordsFromRefs(cells: CellRef[] | undefined): CellCoord[] {
  if (!cells?.length) {
    return [];
  }
  return cells.map((cell) => ({
    row_number: cell.row_number,
    floor: cell.floor,
    col_number: cell.col_number,
  }));
}

export function initialCellsKey(cells: CellCoord[]): string {
  return cells
    .map((cell) => warehouseCellKey(cell))
    .sort()
    .join('|');
}

export function shouldSyncInitialCells(
  syncedKey: string,
  incomingKey: string,
): boolean {
  return syncedKey !== incomingKey;
}
